<script>
import {
  parseWidth,
  parseMinWidth,
  compose
} from "element-ui/packages/table/src/util.js";
import { cellForced, defaultRenderCell } from "./config"; // element-ui config
import ElCheckbox from "element-ui/packages/checkbox";

function alignFormat(align) {
  return align ? "is-" + align : null;
}

export default {
  name: "GtTableColumn",

  components: {
    ElCheckbox
  },
  props: {
    // 类型，功能暂时未实现
    type: {
      type: String,
      default: "default"
    },

    prop: String,
    property: String,

    label: String,

    minWidth: {},

    width: {},

    align: String
  },

  data() {
    return {};
  },

  computed: {
    owner() {
      let parent = this.$parent;
      while (parent && !parent.isTable) {
        parent = parent.$parent;
      }
      return parent;
    }
  },

  methods: {
    setColumnRenders(column) {
      if (column.type !== "selection") {
        column.renderHeader = (h, scope) => {
          const renderHeader = this.$scopedSlots.header;
          return renderHeader ? renderHeader(scope) : column.label;
        };
      }

      let originRenderCell = column.renderCell;
      originRenderCell = originRenderCell || defaultRenderCell;

      column.renderCell = (h, data) => {
        let children = null;
        if (this.$scopedSlots.default) {
          children = this.$scopedSlots.default(data);
        } else {
          children = originRenderCell(h, data);
        }

        return <div>{children}</div>;
      };
      return column;
    },

    setColumnForcedProps(column) {
      // 对于特定类型的 column，某些属性不允许设置
      const type = column.type;
      const source = cellForced[type] || {};
      Object.keys(source).forEach(prop => {
        let value = source[prop];
        if (value !== undefined) {
          column[prop] = value;
        }
      });
      return column;
    },

    getColumnElIndex(children, child) {
      return [].indexOf.call(children, child);
    },

    registerWatchers() {
      const props = ["label", "property", "minWidth", "width", "align"];
      // 一些属性具有别名
      const aliases = {
        prop: "property"
      };
      const allAliases = props.reduce((prev, cur) => {
        prev[cur] = cur;
        return prev;
      }, aliases);

      Object.keys(allAliases).forEach(key => {
        const columnKey = aliases[key];

        this.$watch(key, newVal => {
          this.columnConfig[columnKey] = newVal;
        });
      });
    }
  },

  created() {
    let column = {
      type: this.type,
      property: this.property || this.prop,
      label: this.label,
      width: parseWidth(this.width),
      minWidth: parseMinWidth(this.minWidth),
      realWidth: undefined, // [unusefull] 与element-ui不同的设计，这里 realWidth 无用
      align: alignFormat(this.align),
      renderHeader: undefined,
      renderCell: undefined
    };
    // 注意 compose 中函数执行的顺序是从右到左
    const chains = compose(this.setColumnRenders, this.setColumnForcedProps);
    column = chains(column);

    this.columnConfig = column;

    // set watcher
    this.registerWatchers();
  },

  mounted() {
    const owner = this.owner;
    const columnIndex = this.getColumnElIndex(
      owner.$refs.hiddenColumns.children,
      this.$el
    );

    owner.store.commit("insertColumn", this.columnConfig, columnIndex, null);
  },

  destroyed() {
    if (!this.owner) return;

    this.owner.store.commit("removeColumn", this.columnConfig, null);
  },

  render(h) {
    // element-ui渲染了 slots 用于需要计算合并表头 我们不需要
    return h("div");
  }
};
</script>
